import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Card, CardContent, Typography, Button, Grid } from "@mui/material";
import s from "./newPuja.module.css";
import { getBaseUrl2 } from "../../utils";
import Loder from "../../Loder/Loder";
import DataNotFound from "../ErrorPage/DataNotFound";
import { notificationHandler } from "../../utils/Notification"
import { getPujaById_api } from "../api/newPuja";

const StyledCard = styled(Card)(({ theme }) => ({
  margin: "20px",
  padding: "20px",
  backgroundColor: "#f9f9f9",
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: "10px",
}));
const ViewPujaDetails = () => {
  const navigate = useNavigate();
  const [puja, setPuja] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
const location= useLocation()
console.log(puja,"this is get hte data from the previous page")
  useEffect(() => {
    fetchPujaDetails();
  }, [location]);

  async function fetchPujaDetails() {
    setIsLoading(true);
    try {
      let res = await getPujaById_api(location?.state?.data?._id);
      if (res.data.status) {
        setPuja(res?.data.data?.event);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      notificationHandler({ type: "danger", msg: error.message });
    }
  }

  if (isLoading) return <Loder loading={isLoading} />;
  if (!puja) return <DataNotFound />;

  return (
    <div className={s["puja-details-container"]}>
      <StyledCard>
        <CardContent>
          <StyledTypography variant="h4" gutterBottom>
            Puja Details
          </StyledTypography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <StyledTypography variant="h6">General Information</StyledTypography>
              <StyledTypography><strong>Name:</strong> {puja.name}</StyledTypography>
              <StyledTypography><strong>Title (Hindi):</strong> {puja.titleHindi}</StyledTypography>
              <StyledTypography><strong>Location:</strong> {puja.location}</StyledTypography>
              <StyledTypography><strong>Hindi Location:</strong> {puja.hindiLocation}</StyledTypography>
              <StyledTypography><strong>Primary God:</strong> {puja.primaryGodName}</StyledTypography>
              <StyledTypography><strong>Purpose:</strong> {puja.purpose}</StyledTypography>
              <StyledTypography><strong>Status:</strong> {puja.status}</StyledTypography>
              <StyledTypography><strong>Priority:</strong> {puja.priority}</StyledTypography>
              <StyledTypography><strong>Date:</strong> {puja.date?.slice(0, 10)}</StyledTypography>
              <StyledTypography><strong>Created At:</strong> {puja.created_at?.slice(0, 10)}</StyledTypography>
              <StyledTypography><strong>Updated At:</strong> {puja.updated_at?.slice(0, 10)}</StyledTypography>
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTypography variant="h6">Pricing</StyledTypography>
              <StyledTypography><strong>Price (INR):</strong> {puja.price}</StyledTypography>
              <StyledTypography><strong>Price (USD):</strong> {puja.priceInDollar}</StyledTypography>
              <StyledTypography><strong>Purchased Number:</strong> {puja.purchasedNumber}</StyledTypography>
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Description</StyledTypography>
              <StyledTypography component="div" dangerouslySetInnerHTML={{ __html: `<strong>English:</strong> ${puja.desc}` }} />
              <StyledTypography component="div" dangerouslySetInnerHTML={{ __html: `<strong>Hindi:</strong> ${puja.hindiDesc}` }} />
              <StyledTypography><strong>Short Description (English):</strong> <span style={{ whiteSpace: 'pre-line' }}>{puja.shortdesc}</span></StyledTypography>
              <StyledTypography><strong>Short Description (Hindi):</strong> <span style={{ whiteSpace: 'pre-line' }}>{puja.shorthindiDesc}</span></StyledTypography>
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Temple Details</StyledTypography>
              <StyledTypography component="div" dangerouslySetInnerHTML={{ __html: `<strong>Temple:</strong> ${puja.madirDetails}` }} />
              <StyledTypography component="div" dangerouslySetInnerHTML={{ __html: `<strong>Temple (Hindi):</strong> ${puja.madirhindiDetails}` }} />
              {puja.madirImage && (
                <img
                  src={getBaseUrl2() + puja.madirImage}
                  alt="Temple"
                  style={{ width: "100px", height: "100px", marginTop: "10px" }}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Thumbnails</StyledTypography>
              {puja.thumbnail?.map((thumb, index) => (
                <img
                  key={thumb._id}
                  src={getBaseUrl2() + thumb.url}
                  alt={`Thumbnail ${index + 1}`}
                  style={{ width: "100px", height: "100px", marginRight: "10px" }}
                />
              ))}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Benefits</StyledTypography>
              {puja.benefits?.map((benefit) => (
                <div key={benefit._id}>
                  <StyledTypography><strong>{benefit.header}:</strong> {benefit.description}</StyledTypography>
                  <StyledTypography><strong>{benefit.hindiHeader}:</strong> {benefit.hindiDescription}</StyledTypography>
                </div>
              ))}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Offerings</StyledTypography>
              {puja.offerings?.map((offering) => (
                <div key={offering._id}>
                  <StyledTypography><strong>{offering.title}:</strong> ₹{offering.price} / ${offering.dollarPrice}</StyledTypography>
                  <StyledTypography><strong>{offering.hindiTitle}:</strong> ₹{offering.price} / ${offering.dollarPrice}</StyledTypography>
                </div>
              ))}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Number of Members</StyledTypography>
              {puja.numberOfMembers?.map((member) => (
                <div key={member._id}>
                  <StyledTypography><strong>{member.title}:</strong> ₹{member.price} / ${member.dollarPrice}</StyledTypography>
                  <StyledTypography><strong>{member.hindiTitle}:</strong> ₹{member.price} / ${member.dollarPrice}</StyledTypography>
                </div>
              ))}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Prasad Home Delivery</StyledTypography>
              {puja.prasadHomeDelivery?.map((prasad) => (
                <div key={prasad._id}>
                  <StyledTypography><strong>{prasad.title}:</strong> ₹{prasad.price} / ${prasad.dollarPrice}</StyledTypography>
                  <StyledTypography><strong>{prasad.hindiTitle}:</strong> ₹{prasad.price} / ${prasad.dollarPrice}</StyledTypography>
                </div>
              ))}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Puja Process</StyledTypography>
              {puja.pujaProcess?.map((step) => (
                <div key={step._id}>
                  <StyledTypography><strong>Step {step.stepNumber} - {step.title}:</strong> {step.description}</StyledTypography>
                  <StyledTypography><strong>Step {step.stepNumber} - {step.hindiTitle}:</strong> {step.hindiDescription}</StyledTypography>
                </div>
              ))}
            </Grid>
            <Grid item xs={12}>
              <StyledTypography variant="h6">Live Darshan Links</StyledTypography>
              {puja.liveDarshanLinks?.map((link, index) => (
                <StyledTypography key={index}>
                  <a href={link} target="_blank" rel="noopener noreferrer">{link}</a>
                </StyledTypography>
              ))}
            </Grid>
          </Grid>
          <Button
            variant="contained"
            color="warning"
            onClick={() => navigate("/new-puja-list")}
            style={{ marginTop: "20px" }}
          >
            Back to Puja List
          </Button>
        </CardContent>
      </StyledCard>
      <Loder loading={isLoading} />
    </div>
  );
};
export default ViewPujaDetails;